'use client';

import { useState } from 'react';
import Link from 'next/link';
import { Button } from './Button';
import { cn } from '@/lib/utils';

export function MainNav({ transparent = false }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Desktop navigation */}
      <div className="hidden lg:flex lg:gap-x-12">
        <Link
          href="/om-stiftelsen"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Om stiftelsen
        </Link>
        <Link
          href="/vart-arbete"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Vårt arbete
        </Link>
        <Link
          href="/ansok-om-stod"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Ansök om stöd
        </Link>
        <Link
          href="/stod-oss"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Stöd oss
        </Link>
        <Link
          href="/nyheter-och-uppdateringar"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Nyheter och uppdateringar
        </Link>
      </div>

      {/* Contact button */}
      <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:gap-8">
        <Button href="/kontakta-oss" invert={transparent}>
          Kontakta oss
        </Button>
      </div>
    </>
  );
}
